var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 22.75C7.9665 22.75 8.75 21.9665 8.75 21C8.75 20.0335 7.9665 19.25 7 19.25C6.0335 19.25 5.25 20.0335 5.25 21C5.25 21.9665 6.0335 22.75 7 22.75Z",
    fill: "#E5CC82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.105 19.25H13.895C12.9865 19.25 12.25 19.9865 12.25 20.895V21.105C12.25 22.0135 12.9865 22.75 13.895 22.75H35.105C36.0135 22.75 36.75 22.0135 36.75 21.105V20.895C36.75 19.9865 36.0135 19.25 35.105 19.25Z",
    fill: "#E5CC82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.105 28H6.895C5.98649 28 5.25 28.7365 5.25 29.645V29.855C5.25 30.7635 5.98649 31.5 6.895 31.5H35.105C36.0135 31.5 36.75 30.7635 36.75 29.855V29.645C36.75 28.7365 36.0135 28 35.105 28Z",
    fill: "#E5CC82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.105 10.5H6.895C5.98649 10.5 5.25 11.2365 5.25 12.145V12.355C5.25 13.2635 5.98649 14 6.895 14H35.105C36.0135 14 36.75 13.2635 36.75 12.355V12.145C36.75 11.2365 36.0135 10.5 35.105 10.5Z",
    fill: "#E5CC82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burger_menu.803db55fdd1592dbf9819ff7b3b60e81.svg";
export { ForwardRef as ReactComponent };